// extracted by mini-css-extract-plugin
export default {"container":"VerticalAdjaText_container__PAJ5L","small":"VerticalAdjaText_small__iWpCq","large":"VerticalAdjaText_large__b8Eir"};